import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { RecipientRequestType, RequestTypeType } from '@/types/vendorVaultTypes';

export const getRecipientRequestsApi = (
  params?: ApiParams
): Promise<ApiResponseType<ListResponseType<RecipientRequestType>>> =>
  authApiService.GET('/vendor-vault/requests/', params);

export const getRecipientRequestCountsApi = (): Promise<ApiResponseType<Partial<Record<RequestTypeType, number>>>> =>
  authApiService.GET('/vendor-vault/requests/', { counts: '1' });
